/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The GetScreenShotFromVideoRequest model module.
 * @module model/GetScreenShotFromVideoRequest
 * @version V1
 */
class GetScreenShotFromVideoRequest {
    /**
     * Constructs a new <code>GetScreenShotFromVideoRequest</code>.
     * @alias module:model/GetScreenShotFromVideoRequest
     */
    constructor() { 
        
        GetScreenShotFromVideoRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>GetScreenShotFromVideoRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GetScreenShotFromVideoRequest} obj Optional instance to populate.
     * @return {module:model/GetScreenShotFromVideoRequest} The populated <code>GetScreenShotFromVideoRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetScreenShotFromVideoRequest();

            if (data.hasOwnProperty('proofFileId')) {
                obj['proofFileId'] = ApiClient.convertToType(data['proofFileId'], 'Number');
            }
            if (data.hasOwnProperty('timeStamps')) {
                obj['timeStamps'] = ApiClient.convertToType(data['timeStamps'], ['Number']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>GetScreenShotFromVideoRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GetScreenShotFromVideoRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['timeStamps'])) {
            throw new Error("Expected the field `timeStamps` to be an array in the JSON data but got " + data['timeStamps']);
        }

        return true;
    }


}



/**
 * @member {Number} proofFileId
 */
GetScreenShotFromVideoRequest.prototype['proofFileId'] = undefined;

/**
 * @member {Array.<Number>} timeStamps
 */
GetScreenShotFromVideoRequest.prototype['timeStamps'] = undefined;






export default GetScreenShotFromVideoRequest;

